export default __webpack_public_path__ + "static/media/elo-books-details-logo.e563ee70.svg";